(() => {
  const colorDefinitions = [
    { value: 'Black', aliases: ['black', 'balck', 'blakc', 'bakck', 'tikur', 'tiqur', 'ጥቁር'] },
    { value: 'White', aliases: ['white', 'wihte', 'whte', 'nech', 'ነጭ'] },
    { value: 'Red', aliases: ['red', 'redd', 'key', 'qey', 'ቀይ'] },
    { value: 'Blue', aliases: ['blue', 'semayawi', 'ሰማያዊ'] },
    { value: 'Green', aliases: ['green', 'arenguade', 'አረንጓዴ'] },
    { value: 'Brown', aliases: ['brown', 'bunama', 'ቡናማ'] },
    { value: 'Beige', aliases: ['beige', 'bezh', 'ቤዥ'] },
    { value: 'Pink', aliases: ['pink', 'rose', 'roze', 'ሮዝ'] },
    { value: 'Grey', aliases: ['grey', 'gray', 'giracha', 'ግራጫ'] },
    { value: 'Purple', aliases: ['purple', 'hamrawi', 'ሐምራዊ'] },
    { value: 'Cream', aliases: ['cream', 'krem', 'ክሬም'] }
  ];

  const productIntents = [
    { label: 'dresses', term: 'dress', path: '/collections/dresses', aliases: ['dress', 'dresses', 'dres', 'ress', 'resss', 'gown', 'maxi dress', 'mini dress', 'bodycon', 'kemis', 'qemis', 'ቀሚስ'], excludes: ['dress shirt', 'dress shoes', 'dress shoe', 'dress pants', 'dress trousers'] },
    { label: 'skirts', term: 'skirt', path: '/collections/skirts', aliases: ['skirt', 'skirts', 'ye setoch gunna', 'ጉርድ ቀሚስ', 'ስከርት'] },
    { label: 'tops', term: 'top', path: '/collections/tops', aliases: ['top', 'tops', 'crop top', 'blouse', 'blawez', 'ቶፕ', 'ብላውዝ'] },
    { label: 'jumpsuits', term: 'jumpsuit', path: '/collections/jumpsuits', aliases: ['jumpsuit', 'jumpsuits', 'jump suit', 'ጃምፕሱት'] },
    { label: 'cardigans', term: 'cardigan', path: '/collections/cardigans', aliases: ['cardigan', 'cardigans', 'kardigan', 'ካርዲጋን'] },
    { label: 'blazers', term: 'blazer', path: '/collections/blazers-vests', aliases: ['blazer', 'blazers', 'የሴቶች ብሌዘር', 'ብሌዘር'] },
    { label: 'T-shirts', term: 't-shirt', path: '/collections/t-shirts', aliases: ['t-shirt', 't shirt', 'tshirt', 'tee', 'ti shert', 'ቲሸርት'] },
    { label: 'shirts', term: 'shirt', path: '/collections/shirts', aliases: ['shirt', 'shirts', 'button down', 'shemiz', 'shemyz', 'ሸሚዝ'] },
    { label: 'hoodies', term: 'hoodie', path: '/collections/long-sleeve-hoodie-1', aliases: ['hoodie', 'hoodies', 'hudi', 'ሁዲ'] },
    { label: 'jackets', term: 'jacket', path: '/collections/jackets', aliases: ['jacket', 'jackets', 'coat', 'bomber', 'jaket', 'ጃኬት', 'ኮት'] },
    { label: 'sweaters', term: 'sweater', path: '/collections/sweaters', aliases: ['sweater', 'sweaters', 'pullover', 'knitwear', 'shurab', 'ሹራብ'] },
    { label: 'tracksuits', term: 'tracksuit', path: '/collections/tracksuits', aliases: ['tracksuit', 'tracksuits', 'track suit', 'ye sport komplet', 'ትራክሱት', 'የስፖርት ኮምፕሌት'] },
    { label: 'vests', term: 'vest', path: '/collections/vests', aliases: ['vest', 'vests', 'waistcoat', 'vesit', 'ቬስት', 'ቬስቶች'] },
    { label: 'formal shoes', term: 'formal shoes', path: '/collections/dress-shoes-1', aliases: ['dress shoes', 'formal shoes', 'office shoes', 'ye sera chama', 'የሥራ ጫማ'] },
    { label: 'sandals', term: 'sandals', path: '/collections/sandals', aliases: ['sandal', 'sandals', 'sandaloch', 'ሳንዳል', 'ሳንዳሎች'] },
    { label: 'sneakers', term: 'sneakers', path: '/collections/sneakers', aliases: ['sneaker', 'sneakers', 'trainer', 'trainers', 'sport shoes', 'sports shoes', 'sport chama', 'የስፖርት ጫማ'] },
    { label: 'shoes', term: 'shoes', path: '/collections/sneakers', aliases: ['shoe', 'shoes', 'chama', 'ጫማ'] },
    { label: 'bags', term: 'bag', path: '/collections/backpack', aliases: ['bag', 'bags', 'handbag', 'hand bag', 'satchel', 'borsa', 'ቦርሳ'] },
    { label: 'backpacks', term: 'backpack', path: '/collections/backpack', aliases: ['backpack', 'backpacks', 'back pack', 'school bag', 'schoolbag', 'borsa', 'ye timhirt bet borsa', 'ቦርሳ', 'የትምህርት ቤት ቦርሳ'] },
    { label: 'travel bags', term: 'travel bag', path: '/collections/duffel-bags', aliases: ['duffel bag', 'duffel bags', 'duffel', 'travel bag', 'gym bag', 'ye guzo borsa', 'የጉዞ ቦርሳ'] },
    { label: 'jeans', term: 'jeans', path: '/collections/trousers-1', aliases: ['jean', 'jeans', 'denim jeans', 'denim pants', 'jinse', 'ጂንስ'] },
    { label: 'trousers', term: 'trousers', path: '/collections/trousers-1', aliases: ['trouser', 'trousers', 'pants', 'pant', 'slacks', 'suri', 'surri', 'ሱሪ'], excludes: ['jean', 'jeans', 'denim'] },
    { label: 'shorts', term: 'shorts', path: '/collections/shorts-sets', aliases: ['shorts', 'short', 'qumta', 'ቁምጣ'] },
    { label: 'suits', term: 'suit', path: '/collections/suits', aliases: ['suit', 'suits', 'tuxedo', 'suf', 'ሱፍ', 'ቱክሲዶ'] },
    { label: 'activewear', term: 'activewear', path: '/collections/active-wear', aliases: ['activewear', 'active wear', 'gym wear', 'workout clothes', 'sport clothes', 'sport libs', 'የስፖርት ልብስ', 'የጂም ልብስ'] },
    { label: 'watches', term: 'watch', path: '/collections/watches', aliases: ['watch', 'watches', 'seat', 'se-at', 'ሰዓት', 'ሰዓቶች'] },
    { label: 'sunglasses', term: 'sunglasses', path: '/collections/sunglasses', aliases: ['sunglass', 'sunglasses', 'sun glasses', 'menetsir', 'ye tsehay menetsir', 'የፀሐይ መነጽር', 'መነጽር'] },
    { label: 'jewellery', term: 'jewellery', path: '/collections/jewellery', aliases: ['jewelry', 'jewellery', 'necklace', 'bracelet', 'ring', 'getaget', 'ጌጣጌጥ', 'አንገት ሐብል'] },
    { label: 'perfume', term: 'perfume', path: '/collections/perfume', aliases: ['perfume', 'fragrance', 'scent', 'shito', 'ሽቶ'] },
    { label: 'Habesha clothing', term: 'habesha clothing', path: '/collections/habesha-clothing', aliases: ['habesha clothing', 'habesha', 'habesha clothes', 'traditional ethiopian', 'ye habesha libs', 'የሐበሻ ልብስ', 'ሐበሻ'] },
    { label: 'premium options', term: 'premium fashion', path: '/collections/premium-collection', aliases: ['premium', 'luxury', 'high end', 'expensive', 'primiem', 'lakshiri', 'ፕሪሚየም', 'ላክዠሪ'] },
    { label: 'ready-now options', term: 'ready now', path: '/collections/limited-size-collection', aliases: ['ready now', 'in stock', 'same day', 'today', 'limited size', 'ahun yal', 'zare', 'አሁን ያለ', 'ዛሬ', 'በቀን'] }
  ];

  productIntents.push(
    { label: 'skincare', term: 'skin care', path: '/collections/shaba-skincare', aliases: ['skin care', 'skincare', 'facewash', 'face wash', 'sunscreen'] },
    { label: 'jalabiya', term: 'djellaba', path: '/collections/jalabiya', aliases: ['jalabiya', 'jellabiya', 'jelebya', 'djellaba', 'thobe', 'thobes'] }
  );

  const styleDefinitions = [
    { term: 'striped', aliases: ['striped', 'stripe', 'stripes', 'strip', 'line pattern', 'balemesmer', 'bale mesmer', 'ባለመስመር', 'መስመር'] },
    { term: 'slim fit', aliases: ['slim fit', 'fitted', 'skinny fit', 'slimfit', 'tebam', 'ጠባብ'] },
    { term: 'oversized', aliases: ['oversized', 'over size', 'baggy', 'loose fit', 'wesf', 'ሰፊ', 'ወርድ'] },
    { term: 'floral', aliases: ['floral', 'flower print', 'flowers', 'abeba', 'አበባ', 'የአበባ'] },
    { term: 'plain', aliases: ['plain', 'solid color', 'no design', 'simple', 'netela qelem', 'ነጠላ ቀለም'] },
    { term: 'leather', aliases: ['leather', 'faux leather', 'koda', 'ቆዳ'] },
    { term: 'denim', aliases: ['denim', 'jean jacket', 'jinse', 'ጂንስ'] },
    { term: 'vintage', aliases: ['vintage', 'retro', 'old money', 'classic', 'ክላሲክ'] },
    { term: 'long sleeve', aliases: ['long sleeve', 'long sleeves', 'rejim ej', 'ረጅም እጅ'] },
    { term: 'short sleeve', aliases: ['short sleeve', 'short sleeves', 'acher ej', 'አጭር እጅ'] },
    { term: 'modest', aliases: ['modest', 'covered', 'full length', 'hijab friendly', 'muslim', 'ሙሉ ልብስ'] },
    { term: 'cargo', aliases: ['cargo', 'many pockets', 'pocket pants', 'ካርጎ'] },
    { term: 'formal', aliases: ['formal', 'smart', 'elegant', 'classy', 'foormal', 'መደበኛ'] },
    { term: 'casual', aliases: ['casual', 'everyday', 'daily', 'kazhual', 'ካዥዋል'] },
    { term: 'sporty', aliases: ['sporty', 'athletic', 'streetwear', 'street wear', 'ስፖርቲ'] }
  ];

  const occasionDefinitions = [
    { term: 'party', aliases: ['club', 'nightclub', 'club outfit', 'party', 'party outfit', 'night out', 'date night', 'going out', 'klub', 'party libs', 'ክለብ', 'ፓርቲ', 'የምሽት ልብስ'] },
    { term: 'office', aliases: ['office', 'work outfit', 'interview', 'business', 'meeting', 'sira', 'ye sira libs', 'ቢሮ', 'ስራ', 'ሥራ', 'ኢንተርቪው'] },
    { term: 'wedding', aliases: ['wedding', 'engagement', 'ceremony', 'formal event', 'serg', 'ሰርግ', 'ተሳትፎ'] },
    { term: 'gym', aliases: ['gym', 'workout', 'running', 'training', 'exercise', 'jim', 'ጂም', 'ስፖርት'] },
    { term: 'school', aliases: ['school', 'back to school', 'class', 'student', 'timhirt bet', 'ትምህርት ቤት', 'ተማሪ'] },
    { term: 'winter', path: '/collections/winter-collection', aliases: ['winter', 'cold weather', 'rainy season', 'warm clothes', 'kiremt', 'bired', 'ክረምት', 'ብርድ'] },
    { term: 'travel', aliases: ['travel', 'airport', 'trip', 'vacation', 'guzo', 'ጉዞ', 'አየር ማረፊያ'] },
    { term: 'gift', aliases: ['gift', 'present', 'for my boyfriend', 'for my girlfriend', 'birthday gift', 'sidet', 'ስጦታ', 'የልደት ስጦታ'] }
  ];

  const audienceDefinitions = [
    { value: 'women', label: 'women', path: '/collections/female', aliases: ['women', 'woman', 'female', 'lady', 'ladies', 'set', 'setoch', 'ሴት', 'ሴቶች', 'ለሴት'] },
    { value: 'men', label: 'men', query: 'men', aliases: ['men', 'man', 'male', 'gentleman', 'mens', 'wend', 'wendoch', 'ወንድ', 'ወንዶች', 'ለወንድ'] },
    { value: 'kids', label: 'kids', query: 'kids', aliases: ['boy', 'boys', 'girl', 'girls', 'kid', 'kids', 'child', 'children', 'lij', 'ljoch', 'lijoch', 'ye lijoch', 'ልጅ', 'ልጆች', 'የልጅ', 'የልጆች'] },
    { value: 'toddler', label: 'toddler', query: 'toddler', aliases: ['toddler', 'toddlers', 'baby', 'little child', 'tinsh lij', 'baby lij', 'ታዳጊ', 'ህፃን', 'ሕፃን', 'ትንሽ ልጅ'] }
  ];

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[’']/g, '').replace(/[\-_/,]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function hasAlias(text, alias) {
    const cleanAlias = normalize(alias);
    if (!cleanAlias) return false;
    if (/^[a-z0-9 ]+$/.test(cleanAlias)) {
      const escaped = cleanAlias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
      return new RegExp(`(^|[^a-z0-9])${escaped}([^a-z0-9]|$)`, 'i').test(text);
    }
    return text.includes(cleanAlias);
  }

  function editDistance(left, right) {
    const a = normalize(left);
    const b = normalize(right);
    const rows = Array.from({ length: a.length + 1 }, (_, index) => [index]);
    for (let column = 0; column <= b.length; column += 1) rows[0][column] = column;
    for (let row = 1; row <= a.length; row += 1) {
      for (let column = 1; column <= b.length; column += 1) {
        const cost = a[row - 1] === b[column - 1] ? 0 : 1;
        rows[row][column] = Math.min(
          rows[row - 1][column] + 1,
          rows[row][column - 1] + 1,
          rows[row - 1][column - 1] + cost,
        );
        if (
          row > 1 && column > 1 &&
          a[row - 1] === b[column - 2] &&
          a[row - 2] === b[column - 1]
        ) {
          rows[row][column] = Math.min(rows[row][column], rows[row - 2][column - 2] + 1);
        }
      }
    }
    return rows[a.length][b.length];
  }

  function findDefinition(text, definitions) {
    const normalizedText = normalize(text);
    const exact = definitions
      .flatMap((definition, definitionIndex) => definition.aliases.map((alias) => {
        const normalizedAlias = normalize(alias);
        return { definition, definitionIndex, alias: normalizedAlias, words: normalizedAlias.split(' ').length, position: normalizedText.lastIndexOf(normalizedAlias) };
      }))
      .filter((candidate) => hasAlias(text, candidate.alias))
      .sort((a, b) => b.words - a.words || b.alias.length - a.alias.length || b.position - a.position || a.definitionIndex - b.definitionIndex)[0];
    if (exact) return exact.definition;

    if (!definitions.every((definition) => productIntents.includes(definition))) return undefined;
    const words = normalize(text).split(' ').filter((word) => /^[a-z0-9]+$/.test(word) && word.length >= 4);
    let best = null;
    for (const definition of definitions) {
      for (const aliasValue of definition.aliases) {
        const alias = normalize(aliasValue);
        if (!/^[a-z0-9]+$/.test(alias) || alias.length < 4) continue;
        for (const word of words) {
          const distance = editDistance(word, alias);
          const threshold = Math.max(word.length, alias.length) >= 7 ? 2 : 1;
          if (distance > threshold) continue;
          const score = distance / Math.max(word.length, alias.length);
          if (!best || score < best.score || (score === best.score && alias.length > best.alias.length)) {
            best = { definition, alias, score };
          }
        }
      }
    }
    return best?.definition;
  }

  function findDefinitions(text, definitions) {
    return definitions.filter((definition) => definition.aliases.some((alias) => hasAlias(text, alias)));
  }

  function priceNumber(value) {
    const clean = String(value || '').replace(/,/g, '').trim();
    return String(Number.parseFloat(clean) * (/k$/i.test(clean) ? 1000 : 1));
  }

  function detectBudget(raw, explicitBudget) {
    if (explicitBudget) return priceNumber(explicitBudget);
    const amount = '(\\d[\\d,]*(?:\\.\\d+)?\\s*k?)';
    const range = raw.match(new RegExp('between\\s*' + amount + '\\s*(?:birr|br|etb)?\\s*(?:and|to|-)\\s*' + amount, 'i'));
    const before = raw.match(new RegExp('(?:under|below|less than|up to|max(?:imum)?|budget|eske|እስከ|ከ)\\s*(?:br|birr|etb|ብር)?\\s*' + amount, 'i'));
    const after = raw.match(new RegExp(amount + '\\s*(?:br|birr|etb|ብር)?\\s*(?:or less|maximum|max|under|below|betach|wust|wist|በታች|ውስጥ)', 'i'));
    const found = range?.[2] || before?.[1] || after?.[1];
    return found ? priceNumber(found) : '';
  }

  function detectSize(raw, explicitSize) {
    if (explicitSize) return String(explicitSize).toUpperCase();
    const numeric = raw.match(/(?:size|sayz|ሳይዝ)\s*(\d{1,3}(?:\.\d+)?)/i);
    const letter = raw.match(/\b(xxxl|3xl|xxl|2xl|xl|xs|s|m|l)\b/i);
    return (numeric?.[1] || letter?.[1] || '').toUpperCase();
  }

  function extractProductTerms(raw, parsed) {
    let text = normalize(raw);
    const removable = [
      parsed.intent,
      parsed.audience,
      parsed.occasion,
      ...(parsed.styles || []),
      colorDefinitions.find((definition) => definition.value === parsed.color),
    ].filter(Boolean);

    removable.forEach((definition) => {
      (definition.aliases || []).forEach((aliasValue) => {
        const alias = normalize(aliasValue);
        if (!alias) return;
        const escaped = alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
        text = text.replace(new RegExp(`(^|[^a-z0-9])${escaped}([^a-z0-9]|$)`, 'gi'), ' ');
      });
    });

    const noise = new Set([
      'a', 'an', 'and', 'for', 'find', 'give', 'i', 'in', 'is', 'it', 'me', 'my',
      'of', 'on', 'please', 'show', 'that', 'the', 'this', 'to', 'want', 'with',
      'under', 'below', 'less', 'than', 'up', 'budget', 'birr', 'br', 'etb',
      'size', 'colour', 'color', 'mens', 'womens', 'men', 'women',
      'normal', 'regular', 'usual', 'need', 'outfit', 'clothes', 'clothing', 'between', 'or', 'and', 'to', 'now', 'ready', 'not', 'without', 'excluding', 'k',
    ]);
    const sizes = new Set(['xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl', 'xxxl']);
    return text
      .replace(/\b\d[\d,]*(?:\.\d+)?k?\b/g, ' ')
      .split(' ')
      .map((word) => word.trim())
      .filter((word) => word.length > 1 && !noise.has(word) && !sizes.has(word))
      .filter((word) => !parsed.intent || findDefinition(word, [parsed.intent]) !== parsed.intent)
      .filter((word) => !parsed.audience || findDefinition(word, [parsed.audience]) !== parsed.audience)
      .slice(0, 8);
  }

  function parseRequest(raw, explicit = {}) {
    const rawText = String(raw || '');
    const exclusions = [];
    const positiveRaw = rawText.replace(/\b(?:not|without|excluding)\s+([^,;.]+)/gi, (_, phrase) => { exclusions.push(normalize(phrase)); return ''; });
    const text = normalize(positiveRaw);
    const readyDefinition = productIntents.find((item) => item.label === 'ready-now options');
    const premiumDefinition = productIntents.find((item) => item.label === 'premium options');
    const readyNow = readyDefinition.aliases.some((alias) => hasAlias(text, alias));
    const premium = premiumDefinition.aliases.some((alias) => hasAlias(text, alias));
    let intent = findDefinition(text, productIntents.filter((item) => item !== readyDefinition && item !== premiumDefinition));
    const audience = findDefinition(text, audienceDefinitions);
    const occasion = findDefinition(text, occasionDefinitions);
    const styles = findDefinitions(text, styleDefinitions);
    const detectedColors = findDefinitions(text, colorDefinitions).map((item) => item.value);
    const colors = detectedColors.length > 1 && /\bor\b/i.test(text) ? detectedColors : [explicit.color || detectedColors[0]].filter(Boolean);
    const color = colors[0] || '';
    const size = detectSize(text, explicit.size);
    const budget = detectBudget(rawText, explicit.budget);
    const minimumMatch = rawText.match(/between\s*(\d[\d,]*(?:\.\d+)?\s*k?)\s*(?:birr|br|etb)?\s*(?:and|to|-)/i);
    const minBudget = minimumMatch ? priceNumber(minimumMatch[1]) : '';
    const gender = /\bgirls?\b/i.test(text) ? 'girls' : /\bboys?\b/i.test(text) ? 'boys' : '';
    const detailTerms = styles.map((style) => style.term);
    const audienceSearch = Boolean(audience?.query && intent);
    const smart = Boolean(color || occasion || detailTerms.length || audienceSearch);
    let cleanedTerms = positiveRaw;
    [...colorDefinitions.filter((item) => colors.includes(item.value)), ...(readyNow ? [readyDefinition] : []), ...(premium ? [premiumDefinition] : [])].forEach((definition) => {
      definition.aliases.forEach((alias) => { cleanedTerms = normalize(cleanedTerms).replace(normalize(alias), ' '); });
    });
    const productTerms = extractProductTerms(cleanedTerms, { intent, audience, occasion, styles, color });

    let categoryTerm = intent?.term || '';
    if (!categoryTerm && occasion?.term === 'party') categoryTerm = audience?.value === 'men' ? 'shirt' : 'dress';
    if (!categoryTerm && occasion?.term === 'office') categoryTerm = audience?.value === 'women' ? 'dress' : 'shirt';
    if (!categoryTerm && occasion?.term === 'gym') categoryTerm = 'activewear';
    if (!categoryTerm && occasion?.term === 'school') categoryTerm = audience?.value === 'toddler' ? 'toddler' : 'school';
    if (!categoryTerm && occasion?.term === 'wedding') categoryTerm = audience?.value === 'men' ? 'suit' : 'dress';

    if (!intent && categoryTerm) intent = productIntents.find((item) => item.term === categoryTerm);

    const inferredPaths = {
      dress: '/collections/dresses',
      shirt: '/collections/shirts',
      activewear: audience?.value === 'women' ? '/collections/womens-activewear-yoga' : '/collections/active-wear',
      school: '/collections/back-to-school',
      suit: '/collections/suits',
    };
    let targetPath = intent?.path || occasion?.path || inferredPaths[categoryTerm] || audience?.path || '';
    if (audience?.value === 'women' && intent?.label === 'jackets') targetPath = '/collections/jackets-1';
    if (audience?.value === 'women' && intent?.label === 'activewear') targetPath = '/collections/womens-activewear-yoga';
    const exact = Boolean(targetPath && (color || size || budget || styles.length || occasion || audience));

    const queryParts = [];
    if (color && smart) queryParts.push(color.toLowerCase());
    if (audience?.query && smart) queryParts.push(audience.query);
    queryParts.push(...detailTerms);
    if (occasion && !detailTerms.length) queryParts.push(occasion.term);
    if (categoryTerm) queryParts.push(categoryTerm);
    if (!categoryTerm && audience?.query) queryParts.push(audience.query);
    if (!queryParts.length) queryParts.push(text);

    return { colors, exclusions, readyNow, premium, minBudget, gender, raw: String(raw || '').trim(), intent, audience, occasion, styles, productTerms, color, size, budget, smart, exact, targetPath, query: [...new Set([...productTerms, ...queryParts].filter(Boolean))].join(' ') };
  }

  // Keep search analytics inside Shopify. Search text and product clicks are
  // never sent to an external service by this theme script.

  function analyticsId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
      const random = Math.floor(Math.random() * 16);
      const value = character === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function scrubSearchText(value) {
    return String(value || '')
      .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/gi, '[email]')
      .replace(/(?:\+?251|0)\s?\d(?:[\s-]?\d){8,9}/g, '[phone]')
      .replace(/\b\d{5,}\b/g, '[number]')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 140);
  }

  function searchLanguage(value) {
    const text = String(value || '');
    if (/[\u1200-\u137f]/.test(text)) return 'amharic';
    return /[a-z]/i.test(text) ? 'english_or_latin_amharic' : 'other';
  }

  function trackSearchEvent(name, data = {}) {
    const query = scrubSearchText(data.query || data.request || '');
    const event = {
      event: name,
      eventId: analyticsId(),
      searchId: data.searchId || analyticsId(),
      query,
      language: searchLanguage(query),
      page: window.location.pathname,
      sentAt: new Date().toISOString(),
      ...data,
    };
    event.query = query;
    delete event.request;

    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('shaba:search_' + name.replace(/^search_/, ''), event);
      }
    } catch (error) {
      console.debug('Shaba pixel event unavailable', error);
    }

  }

  function buildDestination(parsed, searchUrl = '/search') {
    const params = new URLSearchParams();
    params.set('shaba_request', parsed.raw);
    if (parsed.intent?.label) params.set('shaba_intent', parsed.intent.label);
    if (parsed.audience?.label) params.set('shaba_audience', parsed.audience.label);
    if (parsed.styles.length) params.set('shaba_style', parsed.styles.map((style) => style.term).join(', '));
    if (parsed.occasion?.term) params.set('shaba_occasion', parsed.occasion.term);
    if (parsed.color) params.set('shaba_color', parsed.color);
    if (parsed.size) params.set('shaba_size', parsed.size);
    if (parsed.budget) params.set('shaba_budget', parsed.budget);
    if (parsed.productTerms?.length) params.set('shaba_terms', parsed.productTerms.join(', '));

    const catalogTerms = [
      parsed.audience?.query,
      ...(parsed.productTerms || []),
      ...parsed.styles.map((style) => style.term),
      parsed.intent?.term,
      parsed.occasion?.term,
    ].filter(Boolean);
    if (!catalogTerms.length && parsed.color) catalogTerms.push(parsed.color.toLowerCase());
    if (!catalogTerms.length) catalogTerms.push(parsed.raw);
    params.set('q', [...new Set(catalogTerms)].join(' '));
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('shaba_catalog', '1');
    params.set('shaba_mode', 'catalog');
    return `${searchUrl}?${params.toString()}`;
  }

  function activateFinder(form) {
    if (form.dataset.shabaFinderReady === 'true') return;
    form.dataset.shabaFinderReady = 'true';
    const queryInput = form.querySelector('[name="q"]');
    if (!queryInput) return;
    form.addEventListener('submit', submitFinder);
    form.querySelectorAll('[data-finder-example]').forEach((button) => {
      button.addEventListener('click', () => { queryInput.value = button.dataset.finderExample || button.textContent.trim(); queryInput.focus(); });
    });
  }

  function submitFinder(event) {
      const form = event.target;
      if (!form.matches('form[data-shaba-finder], form.search-page-input__parent')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const queryInput = form.querySelector('[name="q"]');
      if (!queryInput) return;
      const raw = queryInput.value.trim();
      if (!raw) { queryInput.focus(); return; }
      const parsed = parseRequest(raw, {
        budget: form.querySelector('[name="max_price"]')?.value || '',
        size: form.querySelector('[name="size"]')?.value || '',
        color: form.querySelector('[name="color"]')?.value || ''
      });
      const searchId = analyticsId();
      const destinationUrl = new URL(buildDestination(parsed, form.dataset.searchUrl || '/search'), window.location.origin);
      destinationUrl.searchParams.set('shaba_search_id', searchId);
      const destination = destinationUrl.toString();
      trackSearchEvent('search_submitted', {
        searchId,
        query: parsed.raw,
        intent: parsed.intent?.label || '',
        audience: parsed.audience?.label || '',
        occasion: parsed.occasion?.term || '',
        styles: parsed.styles.map((style) => style.term).slice(0, 5),
        color: parsed.color || '',
        size: parsed.size || '',
        budget: parsed.budget || '',
        mode: parsed.exact ? 'exact' : parsed.smart ? 'smart' : 'collection',
        destination: new URL(destination, window.location.origin).pathname,
      });
      window.location.assign(destination);
  }

  window.addEventListener('submit', submitFinder, true);
  window.addEventListener('click', (event) => {
    const button = event.target.closest('[data-shaba-submit]');
    if (button?.form) { event.preventDefault(); event.stopImmediatePropagation(); submitFinder({target: button.form, preventDefault() {}, stopImmediatePropagation() {}}); }
  }, true);
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('form[data-shaba-finder] input[name="q"], form.search-page-input__parent input[name="q"]')) {
      event.preventDefault(); event.stopImmediatePropagation(); submitFinder({ target: event.target.form, preventDefault() {}, stopImmediatePropagation() {} });
    }
  }, true);

  function enhanceResultsFinder() {
    const form = document.querySelector('form.search-page-input__parent');
    if (!form || form.dataset.shabaNativeSearch === 'true') return;
    const previous = form.querySelector('input[name="q"]');
    if (!previous) return;
    const params = new URLSearchParams(window.location.search);
    const queryInput = document.createElement('input');
    queryInput.type = 'search'; queryInput.name = 'q';
    queryInput.value = params.get('shaba_request') || previous.value;
    queryInput.placeholder = 'Add a product, colour, size or budget…';
    queryInput.setAttribute('aria-label', 'Search again with Shaba in English or Amharic');
    queryInput.style.cssText = 'flex:1 1 280px;width:100%;max-width:none;min-width:180px;box-sizing:border-box;padding:14px 16px;border:1px solid #aaa;border-radius:8px;font:inherit;background:#fff;color:#111';
    const button = document.createElement('button');
    button.type = 'submit'; button.className = 'button'; button.dataset.shabaSubmit = ''; button.textContent = 'Find matches';
    form.replaceChildren(queryInput, button);
    form.style.cssText = 'display:flex!important;flex-direction:row!important;flex-wrap:wrap;gap:12px;align-items:center;width:100%;max-width:900px;margin:12px 0 0';
    form.dataset.shabaFinder = ''; form.dataset.shabaNativeSearch = 'true';
    form.dataset.searchUrl = form.getAttribute('action') || '/search';
    const parent = form.parentElement;
    if (parent) { parent.style.padding = '20px 40px'; parent.querySelectorAll('h1,h2,h3').forEach((heading) => heading.hidden = true); }
    if (parent && !parent.querySelector('.shaba-refine-prompt')) {
      const prompt = document.createElement('div');
      prompt.className = 'shaba-refine-prompt';
      prompt.style.cssText = 'display:block;max-width:900px;margin:0';
      prompt.innerHTML = '<strong>SEARCH AGAIN • እንደገና ፈልግ</strong><span>Change the product, colour, size or budget to refine your search.</span>';
      parent.insertBefore(prompt, form);
    }
  }

  function addFinderConfirmation() {
    const params = new URLSearchParams(window.location.search);
    const request = params.get('shaba_request');
    const main = document.querySelector('#MainContent');
    if (!request || !main || document.querySelector('.shaba-search-confirmation')) return;

    if (window.location.pathname.startsWith('/collections/')) {
      const collectionTitle = main.querySelector('h1');
      if (collectionTitle) collectionTitle.textContent = request;
    }

    const note = document.createElement('aside');
    note.className = 'shaba-search-confirmation';
    note.setAttribute('aria-live', 'polite');
    const copy = document.createElement('div');
    const kicker = document.createElement('span');
    const title = document.createElement('strong');
    const detail = document.createElement('p');
    const understood = document.createElement('div');
    const arrow = document.createElement('span');

    kicker.textContent = 'YOUR SEARCH • የፍለጋ ውጤት';
    title.textContent = `“${request}”`;
    const parsed = parseRequest(request, { budget: params.get('shaba_budget'), size: params.get('shaba_size'), color: params.get('shaba_color') });
    const signals = [parsed.intent?.label, parsed.audience?.label, ...parsed.styles.map((style) => style.term)].filter(Boolean);
    if (parsed.colors.length) signals.push(parsed.colors.join(' or '));
    if (parsed.size) signals.push(`Size ${parsed.size}`);
    if (parsed.budget) signals.push(parsed.minBudget ? `Br${Number(parsed.minBudget).toLocaleString()}–${Number(parsed.budget).toLocaleString()}` : `Up to Br${Number(parsed.budget).toLocaleString()}`);
    if (parsed.readyNow) signals.push('Ready now');
    parsed.exclusions.forEach((term) => signals.push(`Excluding ${term}`));
    understood.className = 'shaba-understood-signals';
    signals.forEach((signal) => {
      const chip = document.createElement('i');
      chip.textContent = signal;
      understood.appendChild(chip);
    });
    detail.textContent = parsed.occasion
      ? `Category suggestions for ${parsed.occasion.term}. Colour, size and price filters apply to the same available option; check the style before ordering.`
      : 'Colour, size and price filters apply together to the available option shown.';
    arrow.textContent = '↓';
    arrow.setAttribute('aria-hidden', 'true');
    copy.append(kicker, title, understood, detail);
    note.append(copy, arrow);
    main.prepend(note);
  }

  function showSelectedVariantImages() {
    const params = new URLSearchParams(window.location.search);
    if (!params.get('shaba_color')) return;

    document.querySelectorAll('product-card-link[data-featured-media-url]').forEach((card) => {
      const rawUrl = card.getAttribute('data-featured-media-url');
      const image = card.querySelector('slideshow-slide img, .product-media__image');
      if (!rawUrl || !image || image.dataset.shabaVariantImage === rawUrl) return;

      const buildUrl = (width) => {
        const url = new URL(rawUrl, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.toString();
      };
      image.src = buildUrl(832);
      image.srcset = [240, 352, 500, 832, 1200]
        .map((width) => `${buildUrl(width)} ${width}w`)
        .join(', ');
      image.dataset.shabaVariantImage = rawUrl;
    });
  }

  function findNativeResultsRoot(main) {
    const firstCard = main.querySelector('product-card-link');
    if (!firstCard) return null;
    let node = firstCard;
    let candidate = firstCard.parentElement;
    while (node.parentElement && node.parentElement !== main) {
      node = node.parentElement;
      if (node.querySelectorAll('product-card-link').length > 1) candidate = node;
    }
    return candidate;
  }

  function money(value, currencyCode) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    if (currencyCode === 'ETB') return `Br ${amount.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
    return new Intl.NumberFormat('en', { style: 'currency', currency: currencyCode || 'ETB' }).format(amount);
  }

  function buildExactCard(product, currencyCode) {
    const card = document.createElement('a');
    card.className = 'shaba-exact-card';
    card.href = product.url;

    const media = document.createElement('div');
    media.className = 'shaba-exact-card__media';
    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.imageAlt || product.title;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 900;
      media.appendChild(image);
    }
    if (product._shabaConfidence === 'strong') {
      const quality = document.createElement('span');
      quality.className = 'shaba-exact-card__quality';
      quality.textContent = 'Matches filters';
      media.appendChild(quality);
    }

    const body = document.createElement('div');
    body.className = 'shaba-exact-card__body';
    const title = document.createElement('strong');
    title.textContent = product.title;
    const option = document.createElement('span');
    option.textContent = product.variantTitle || 'Choose your size';
    const reasons = document.createElement('div');
    reasons.className = 'shaba-exact-card__matches';
    (product._shabaMatchReasons || []).slice(0, 4).forEach((reason) => {
      const chip = document.createElement('i');
      chip.textContent = reason;
      reasons.appendChild(chip);
    });
    const price = document.createElement('b');
    price.textContent = money(product.price, currencyCode);
    body.append(title, option);
    if (reasons.childElementCount) body.appendChild(reasons);
    body.appendChild(price);
    card.append(media, body);
    return card;
  }

  function catalogSearchText(product) {
    return normalize([
      product.title,
      product.productType,
      ...(product.tags || []),
      ...(product.collections || []),
    ].join(' '));
  }

  function catalogOptionValues(product, names) {
    const wanted = names.map(normalize);
    return Object.entries(product.options || {})
      .filter(([name]) => wanted.some((term) => normalize(name).includes(term)))
      .flatMap(([, values]) => values || [])
      .map(normalize);
  }

  function catalogAudienceMatches(product, audience) {
    if (!audience) return true;
    const text = catalogSearchText(product);
    const aliases = {
      women: ['women', 'womens', 'woman', 'female', 'ladies', 'lady', 'female'],
      men: ['men', 'mens', 'man', 'male', 'gentleman'],
      kids: ['kids', 'kid', 'children', 'childrens', 'child', 'boys', 'girls'],
      toddler: ['toddler', 'toddlers', 'baby', 'babies', 'newborn', 'infant'],
    };
    return (aliases[audience.value] || [audience.value]).some((alias) => hasAlias(text, alias));
  }

  function catalogDefinitionMatches(text, definition) {
    if (!definition) return true;
    if ((definition.excludes || []).some((term) => hasAlias(text, term))) return false;
    return definition.aliases.some((alias) => hasAlias(text, alias));
  }

  function catalogIntentMatches(product, intent) {
    return catalogIntentStrength(product, intent) > 0;
  }

  function catalogIntentStrength(product, intent) {
    if (!intent) return 0;
    const text = catalogSearchText(product);
    const title = normalize(product.title);
    const type = normalize(product.productType);
    const collections = normalize((product.collections || []).join(' '));
    if ((intent.excludes || []).some((term) => hasAlias(title, term) || hasAlias(type, term))) return -5;

    const directTitle = intent.aliases.some((alias) => hasAlias(title, alias));
    const directType = intent.aliases.some((alias) => hasAlias(type, alias));
    const directCollection = intent.aliases.some((alias) => hasAlias(collections, alias))
      || hasAlias(collections, intent.term)
      || hasAlias(collections, intent.label);
    const collectionHandle = intent.path?.split('/').pop();
    if (['skincare', 'jalabiya', 'Habesha clothing', 'activewear', 'travel bags'].includes(intent.label) && (product.collections || []).includes(collectionHandle)) return 5;
    if (intent.label === 'dresses' && /\b(shoes?|pants|trousers|shirts?)\b/.test(type)) return -5;
    if (intent.label === 'bags' && /\b(backpacks?|bags?)\b/.test(type)) return 4;
    if (directType) return 5;
    if (directTitle) return 4;
    if (directType) return 4;
    if (directCollection) return 3;

    const relatedLabels = intent.label === 'shoes' ? new Set(['sneakers', 'formal shoes', 'sandals']) : new Set();
    if (relatedLabels.size) {
      const related = productIntents.find((definition) =>
        relatedLabels.has(definition.label)
        && definition.aliases.some((alias) => hasAlias(title, alias) || hasAlias(type, alias) || hasAlias(collections, alias))
      );
      if (related) return 3;
    }

    if (intent.label === 'jeans' && (product.tags || []).some((tag) => /jeans?|denim/i.test(tag))) return 3;
    if (intent.label === 'activewear' && (product.collections || []).includes('womens-activewear-yoga')) return 4;
    const competingType = productIntents.find((definition) =>
      definition !== intent
      && !relatedLabels.has(definition.label)
      && definition.aliases.some((alias) => hasAlias(title, alias) || hasAlias(type, alias))
    );
    if (competingType) return -4;
    return catalogDefinitionMatches(text, intent) ? 2 : 0;
  }

  function catalogAudienceStrength(product, audience) {
    if (!audience) return 0;
    const title = normalize(product.title);
    const type = normalize(product.productType);
    const collections = normalize((product.collections || []).join(' '));
    const text = catalogSearchText(product);
    const aliases = {
      women: ['women', 'womens', 'woman', 'female', 'ladies', 'lady'],
      men: ['men', 'mens', 'man', 'male', 'gentleman'],
      kids: ['kids', 'kid', 'children', 'childrens', 'child', 'boys', 'girls'],
      toddler: ['toddler', 'toddlers', 'baby', 'babies', 'newborn', 'infant'],
    };
    const collectionAliases = {
      women: ['female', 'women', 'womens'],
      men: ['men', 'mens'],
      kids: ['kids', 'children', 'back to school'],
      toddler: ['toddler', 'baby'],
    };
    const target = aliases[audience.value] || [audience.value];
    const targetCollections = collectionAliases[audience.value] || target;

    const childText = /\b(kids?|childrens?|boys?|girls?|toddler|baby|babies|newborn)\b/;
    const femaleText = /\b(women|womens|womans|woman|female|ladies)\b/;
    if (['men', 'women'].includes(audience.value) && childText.test(title + ' ' + type)) return -5;
    if (audience.value === 'men' && femaleText.test(title + ' ' + type)) return -5;
    if (['kids', 'toddler'].includes(audience.value) && !childText.test(title + ' ' + type + ' ' + collections)) return -5;
    if (audience.value === 'kids' && childText.test(title + ' ' + type)) return 5;
    if (audience.value === 'women' && femaleText.test(type)) return 5;
    if (targetCollections.some((alias) => hasAlias(collections, alias))) return 5;

    const conflictingCollection = Object.entries(collectionAliases).some(([key, values]) =>
      key !== audience.value && values.some((alias) => hasAlias(collections, alias))
    );
    if (conflictingCollection) return -4;

    if (target.some((alias) => hasAlias(title, alias))) return 4;
    if (target.some((alias) => hasAlias(type, alias))) return 3;
    return target.some((alias) => hasAlias(text, alias)) ? 2 : 0;
  }

  function ensureCatalogLoadingStyles() {
    if (document.querySelector('#shaba-catalog-loading-styles')) return;
    const style = document.createElement('style');
    style.id = 'shaba-catalog-loading-styles';
    style.textContent = `
      .shaba-search-loader{display:grid;place-items:center;min-height:380px;padding:52px 20px;text-align:center;background:linear-gradient(180deg,#f7f3ee 0%,#fff 100%);border:1px solid rgba(21,20,18,.08);border-radius:28px;overflow:hidden}
      .shaba-search-loader__mascot{display:block;width:170px;height:220px;margin:auto;object-fit:contain;filter:drop-shadow(0 18px 22px rgba(70,35,20,.16))}
      .shaba-search-loader__fallback{display:none;place-items:center;width:112px;height:112px;margin:auto;border-radius:50%;background:#be4035;color:#fff;font:800 34px/1 system-ui;box-shadow:0 18px 45px rgba(190,64,53,.22);animation:shaba-search-breathe 1.25s ease-in-out infinite}
      .shaba-search-loader strong{display:block;margin-top:20px;font:800 clamp(24px,4vw,42px)/1.1 system-ui;color:#111}
      .shaba-search-loader__copy{display:block;max-width:540px;margin:10px auto 0;font:500 16px/1.5 system-ui;color:#706b66}
      .shaba-search-loader__checks{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:20px}
      .shaba-search-loader__checks i{padding:7px 10px;border:1px solid rgba(21,20,18,.12);border-radius:999px;background:#fff;color:#56514b;font:750 11px/1 system-ui;font-style:normal;letter-spacing:.03em;animation:shaba-search-check 1.8s ease-in-out infinite}
      .shaba-search-loader__checks i:nth-child(2){animation-delay:.18s}.shaba-search-loader__checks i:nth-child(3){animation-delay:.36s}.shaba-search-loader__checks i:nth-child(4){animation-delay:.54s}
      @keyframes shaba-search-breathe{50%{transform:translateY(-8px) scale(1.04)}}
      @keyframes shaba-search-check{0%,100%{opacity:.45;transform:translateY(0)}50%{opacity:1;transform:translateY(-3px)}}
      @media(prefers-reduced-motion:reduce){.shaba-search-loader__fallback,.shaba-search-loader__checks i{animation:none}}
    `;
    document.head.appendChild(style);
  }

  function buildCatalogLoader() {
    ensureCatalogLoadingStyles();
    const loader = document.createElement('div');
    loader.className = 'shaba-search-loader';
    loader.setAttribute('role', 'status');
    loader.setAttribute('aria-live', 'polite');
    const script = [...document.scripts].find((item) => item.src.includes('shaba-finder.js'));
    const mascotUrl = script ? new URL('shaba-search-mascot.gif', script.src).toString() : '';
    loader.innerHTML = `<div><img class="shaba-search-loader__mascot" src="${mascotUrl}" alt="Shaba mascot searching" width="170" height="220"><div class="shaba-search-loader__fallback" aria-hidden="true">S</div><strong>Finding your best matches</strong><span class="shaba-search-loader__copy">Shaba is reading the request first, then ranking the catalog instead of matching random words.</span><div class="shaba-search-loader__checks" aria-hidden="true"><i>Product type</i><i>Who it is for</i><i>Colour & size</i><i>Availability</i></div></div>`;
    const mascot = loader.querySelector('.shaba-search-loader__mascot');
    mascot.addEventListener('error', () => {
      mascot.hidden = true;
      loader.querySelector('.shaba-search-loader__fallback').style.display = 'grid';
    }, { once: true });
    return loader;
  }

  function matchingVariant(product, parsed) {
    const entries = Object.keys(product.options || {});
    const colorIndex = entries.findIndex((name) => ['color', 'colour', 'qelem', 'ቀለም'].some((term) => normalize(name).includes(normalize(term))));
    const sizeIndex = entries.findIndex((name) => ['size', 'shoe size', 'sayz', 'ሳይዝ'].some((term) => normalize(name).includes(normalize(term))));
    return (product.variants || []).find((variant) => {
      if (variant.available === false) return false;
      const variantText = normalize(variant.title);
      if (parsed.intent?.label === 'dresses' && /\b(shirts?|blouses?|pants|trousers|shorts|vests?)\b/.test(variantText) && !/\b(dress|gown)\b/.test(variantText)) return false;
      const values = variant.options || [];
      const colorMatch = !parsed.color || (colorIndex >= 0 && (parsed.colors || [parsed.color]).some((color) => hasAlias(normalize(values[colorIndex]), color)));
      const sizeMatch = !parsed.size || (sizeIndex >= 0 && hasAlias(normalize(values[sizeIndex]), parsed.size));
      const price = Number(variant.price);
      return colorMatch && sizeMatch && Number.isFinite(price)
        && (!parsed.budget || price <= Number(parsed.budget))
        && (!parsed.minBudget || price >= Number(parsed.minBudget));
    });
  }

  function catalogConstraintResult(product, parsed) {
    const text = catalogSearchText(product);
    const title = normalize(product.title);
    const type = normalize(product.productType);
    const productTerms = parsed.productTerms || [];
    const matchedTerms = productTerms.filter((term) => text.includes(normalize(term)));
    const termCoverage = productTerms.length ? matchedTerms.length / productTerms.length : 1;
    const colors = catalogOptionValues(product, ['color', 'colour', 'qelem', 'ቀለም']);
    const sizes = catalogOptionValues(product, ['size', 'shoe size', 'sayz', 'ሳይዝ']);
    const variant = matchingVariant(product, parsed);
    const colorMatch = !parsed.color || Boolean(variant) || (!(product.variants || []).length && colors.some((value) => hasAlias(value, parsed.color)));
    const sizeMatch = !parsed.size || Boolean(variant) || (!(product.variants || []).length && sizes.some((value) => hasAlias(value, parsed.size)));
    const budgetMatch = Boolean(variant);
    const intentStrength = catalogIntentStrength(product, parsed.intent);
    const audienceStrength = catalogAudienceStrength(product, parsed.audience);
    const styleMatches = (parsed.styles || []).filter((style) => style.aliases.some((alias) => hasAlias(text, alias)));
    const styleCoverage = (parsed.styles || []).length ? styleMatches.length / parsed.styles.length : 1;
    const occasionMatch = !parsed.occasion || parsed.occasion.aliases.some((alias) => hasAlias(text, alias));
    const titleIntentMatch = Boolean(parsed.intent && parsed.intent.aliases.some((alias) => hasAlias(title, alias)));
    const typeIntentMatch = Boolean(parsed.intent && parsed.intent.aliases.some((alias) => hasAlias(type, alias)));
    const hardMismatch = Boolean(
      (parsed.intent && intentStrength <= 0)
      || (parsed.audience && audienceStrength <= 0)
      || !colorMatch
      || !sizeMatch
      || !budgetMatch
      || styleCoverage < 1
      || termCoverage < 1
      || (parsed.readyNow && !(product.collections || []).includes('limited-size-collection'))
      || (parsed.premium && !(product.collections || []).includes('premium-collection'))
      || parsed.exclusions.some((term) => { const definition = findDefinition(term, productIntents); return definition ? catalogIntentStrength(product, definition) > 0 : hasAlias(text, term); })
      || (parsed.gender === 'girls' && /\bboys?\b/.test(title + ' ' + type) && !/\bgirls?\b/.test(title + ' ' + type))
      || (parsed.gender === 'boys' && /\bgirls?\b/.test(title + ' ' + type) && !/\bboys?\b/.test(title + ' ' + type))
      || (!parsed.audience && parsed.occasion && /\b(kids?|children|baby|toddler|boys?|girls?)\b/.test(title + ' ' + type))
      || /^(test[\s\d]*|marketplace test)$/i.test(product.title || '')
    );

    let score = 0;
    if (parsed.intent) score += Math.max(0, intentStrength) * 9;
    if (parsed.audience) score += Math.max(0, audienceStrength) * 5;
    if (titleIntentMatch) score += 12;
    if (typeIntentMatch) score += 8;
    if (parsed.color && colorMatch) score += 10;
    if (parsed.size && sizeMatch) score += 8;
    if (parsed.budget && budgetMatch) score += 4;
    score += Math.round(styleCoverage * ((parsed.styles || []).length ? 10 : 0));
    score += Math.round(termCoverage * (productTerms.length ? 10 : 0));
    if (parsed.occasion && occasionMatch) score += 5;
    if (product.available !== false) score += 6;
    else score -= 18;
    if (intentStrength < 0) score -= 60;
    if (audienceStrength < 0) score -= 45;

    const reasons = [];
    if (parsed.intent && intentStrength > 0) reasons.push(parsed.intent.label);
    if (parsed.audience && audienceStrength > 0) reasons.push(parsed.audience.label);
    if (parsed.color && colorMatch) reasons.push((parsed.colors || [parsed.color]).join(' or '));
    if (parsed.size && sizeMatch) reasons.push(`Size ${parsed.size}`);
    styleMatches.slice(0, 2).forEach((style) => reasons.push(style.term));
    if (parsed.budget && budgetMatch) reasons.push(parsed.minBudget ? `Br${Number(parsed.minBudget).toLocaleString()}–${Number(parsed.budget).toLocaleString()}` : `Up to Br${Number(parsed.budget).toLocaleString()}`);

    const confidence = !hardMismatch && score >= 58 ? 'strong' : !hardMismatch && score >= 38 ? 'good' : 'close';
    const displayProduct = variant ? {
      ...product,
      image: variant.image || product.image,
      price: variant.price,
      variantTitle: variant.title,
      url: `${String(product.url || '').split('?')[0]}?variant=${variant.id}`,
    } : { ...product };
    displayProduct._shabaScore = score;
    displayProduct._shabaConfidence = confidence;
    displayProduct._shabaMatchReasons = [...new Set(reasons)];

    return {
      product: displayProduct,
      score,
      hardMismatch,
      intentStrength,
      audienceStrength,
      colorMatch,
      sizeMatch,
      budgetMatch,
      styleCoverage,
      occasionMatch,
      termCoverage,
    };
  }

  async function fetchCatalogCandidates(query, collection = '') {
    const products = [];
    async function getPage(page) {
      const url = new URL(collection ? `/collections/${collection}` : '/search', window.location.origin);
      url.searchParams.set('view', 'shaba-json');
      if (!collection) { url.searchParams.set('type', 'product'); url.searchParams.set('q', query); }
      url.searchParams.set('page', String(page));
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error(`Catalog search returned ${response.status}`);
      return response.json();
    }
    const first = await getPage(1);
    products.push(...(first.products || []));
    const pages = Number(first.pages || 1);
    // Fetch every page of the selected category, with bounded concurrency.
    for (let page = 2; page <= pages; page += 4) {
      const batch = await Promise.all(Array.from({ length: Math.min(4, pages - page + 1) }, (_, index) => getPage(page + index)));
      batch.forEach((data) => products.push(...(data.products || [])));
    }
    return products;
  }

  function candidateCollections(parsed) {
    const label = parsed.intent?.label;
    const audience = parsed.audience?.value;
    if (parsed.readyNow) return ['limited-size-collection'];
    if (['sneakers', 'formal shoes', 'sandals'].includes(label)) return audience === 'women' ? ['shaba-womens-shoes'] : audience === 'men' ? ['shaba-mens-shoes'] : ['kids', 'toddler'].includes(audience) ? ['shaba-kids-shoes'] : ['shaba-mens-shoes', 'shaba-womens-shoes', 'shaba-kids-shoes'];
    if (label === 'shoes') return audience === 'men' ? ['shaba-mens-shoes'] : audience === 'women' ? ['shaba-womens-shoes'] : ['kids', 'toddler'].includes(audience) ? ['shaba-kids-shoes'] : ['shaba-mens-shoes', 'shaba-womens-shoes', 'shaba-kids-shoes'];
    if (['kids', 'toddler'].includes(audience)) return label === 'bags' || label === 'backpacks' ? ['backpack'] : ['shaba-kids-clothing', 'toddler'];
    if (label === 'bags') return ['backpack', 'duffel-bags', 'satchel-bags', 'laptop-bags', 'shaba-womens-bags'];
    if (label === 'jeans' || label === 'trousers') return audience === 'women' ? ['shaba-womens-trousers'] : ['trousers-1', 'shaba-womens-trousers'];
    if (label === 'jackets' && audience === 'women') return ['jackets-1'];
    if (label === 'activewear') return audience === 'women' ? ['womens-activewear-yoga'] : ['active-wear', 'womens-activewear-yoga'];
    if (label === 'dresses' && !audience) return ['dresses', 'shaba-kids-clothing'];
    return parsed.intent?.path ? [parsed.intent.path.split('/').pop()] : [];
  }

  async function renderCatalogResults() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('shaba_catalog') !== '1') return;
    const main = document.querySelector('#MainContent');
    if (!main || main.querySelector('.shaba-exact-results')) return;
    const parsed = parseRequest(params.get('shaba_request') || params.get('q') || '', {
      budget: params.get('shaba_budget') || '',
      size: params.get('shaba_size') || '',
      color: params.get('shaba_color') || '',
    });
    const nativeRoot = findNativeResultsRoot(main);
    if (nativeRoot) nativeRoot.hidden = true;
    const nativeHeading = main.querySelector('h1');
    if (nativeHeading) nativeHeading.hidden = true;

    const section = document.createElement('section');
    section.className = 'shaba-exact-results';
    const header = document.createElement('div');
    header.className = 'shaba-exact-results__header';
    const heading = document.createElement('h2');
    heading.textContent = parsed.raw || 'Your matches';
    const count = document.createElement('p');
    count.textContent = 'Checking the relevant collections…';
    header.append(heading, count);
    const grid = document.createElement('div');
    grid.className = 'shaba-exact-grid';
    const loader = buildCatalogLoader();
    section.append(header, loader, grid);
    grid.hidden = true;
    const confirmation = main.querySelector('.shaba-search-confirmation');
    if (confirmation) confirmation.insertAdjacentElement('afterend', section);
    else main.prepend(section);
    const refineHeader = main.querySelector('.search-page__header');
    if (refineHeader) section.before(refineHeader);

    try {
      const collections = candidateCollections(parsed);
      const batches = collections.length
        ? await Promise.all(collections.map((handle) => fetchCatalogCandidates('', handle)))
        : [await fetchCatalogCandidates(parsed.query)];
      const candidates = [...new Map(batches.flat().map((product) => [product.id, product])).values()];

      const matches = candidates
        .map((product) => catalogConstraintResult(product, parsed))
        .filter((result) => !result.hardMismatch)
        .sort((left, right) => (
          right.score - left.score
          || Number(right.product.available !== false) - Number(left.product.available !== false)
          || Number(left.product.price) - Number(right.product.price)
        ))
        .map((result) => result.product);
      loader.remove();
      grid.hidden = false;
      count.textContent = matches.length === 1 ? '1 matching option' : `${matches.length} matching options`;
      if (!matches.length) {
        const empty = document.createElement('div');
        empty.className = 'shaba-exact-empty';
        empty.innerHTML = '<strong>No product matched every detail.</strong><span>Remove one condition or try a broader product name.</span>';
        grid.replaceWith(empty);
        return;
      }
      let shown = 0;
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'button';
      more.textContent = 'Show more matches';
      const showMore = () => {
        matches.slice(shown, shown + 48).forEach((product) => grid.appendChild(buildExactCard(product, 'ETB')));
        shown = Math.min(shown + 48, matches.length);
        count.textContent = `${shown} of ${matches.length} matching options`;
        more.hidden = shown >= matches.length;
      };
      more.addEventListener('click', showMore);
      section.appendChild(more);
      showMore();
    } catch (error) {
      loader.remove();
      grid.hidden = false;
      console.error('Shaba catalog search failed', error);
      count.textContent = 'Search needs another try';
      const errorBox = document.createElement('div');
      errorBox.className = 'shaba-exact-empty';
      errorBox.innerHTML = '<strong>We could not finish this search.</strong><span>Please try again in a moment.</span>';
      grid.replaceWith(errorBox);
    }
  }

  async function renderExactResults() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('shaba_exact') !== '1') return;
    const collection = params.get('shaba_collection');
    const main = document.querySelector('#MainContent');
    if (!collection || !main || main.querySelector('.shaba-exact-results')) return;

    const nativeRoot = findNativeResultsRoot(main);
    if (nativeRoot) nativeRoot.hidden = true;
    const nativeHeading = main.querySelector('h1');
    if (nativeHeading) nativeHeading.hidden = true;

    const section = document.createElement('section');
    section.className = 'shaba-exact-results';
    const header = document.createElement('div');
    header.className = 'shaba-exact-results__header';
    const heading = document.createElement('h2');
    heading.textContent = params.get('shaba_request') || 'Your closest matches';
    const count = document.createElement('p');
    count.textContent = 'Finding the exact options…';
    header.append(heading, count);
    const grid = document.createElement('div');
    grid.className = 'shaba-exact-grid';
    section.append(header, grid);

    const confirmation = main.querySelector('.shaba-search-confirmation');
    if (confirmation) confirmation.insertAdjacentElement('afterend', section);
    else main.prepend(section);

    const requestParams = new URLSearchParams({ collection });
    const searchId = params.get('shaba_search_id') || analyticsId();
    if (params.get('shaba_color')) requestParams.set('color', params.get('shaba_color'));
    if (params.get('shaba_size')) requestParams.set('size', params.get('shaba_size'));
    if (params.get('shaba_budget')) requestParams.set('budget', params.get('shaba_budget'));
    const terms = [params.get('shaba_terms'), params.get('shaba_audience'), params.get('shaba_style'), params.get('shaba_occasion')].filter(Boolean).join(',');
    if (terms) requestParams.set('terms', terms);

    try {
      // Legacy exact-mode fallback stays same-origin. New searches use the
      // catalog JSON view above and do not depend on an external backend.
      const response = await fetch(`/search?view=shaba-json&type=product&q=${encodeURIComponent(terms || collection)}`);
      if (!response.ok) throw new Error(`Search returned ${response.status}`);
      const data = await response.json();
      const requestedTerms = (params.get('shaba_terms') || '').split(',').map(normalize).filter(Boolean);
      const requestedColor = normalize(params.get('shaba_color'));
      const rankedProducts = (data.products || []).map((product, originalIndex) => {
        const searchableTitle = normalize(`${product.title || ''} ${product.variantTitle || ''}`);
        const titleMatches = requestedTerms.filter((term) => searchableTitle.includes(term)).length;
        const titleCoverage = requestedTerms.length ? titleMatches / requestedTerms.length : 0;
        const exactColor = !requestedColor || normalize(product.matchedColor) === requestedColor;
        return { product, originalIndex, titleMatches, titleCoverage, exactColor };
      });
      const colorMatches = requestedColor ? rankedProducts.filter((item) => item.exactColor) : rankedProducts;
      const usefulTitleMatches = requestedTerms.length ? colorMatches.filter((item) => item.titleMatches > 0) : colorMatches;
      const visibleProducts = (usefulTitleMatches.length ? usefulTitleMatches : colorMatches)
        .sort((left, right) => (
          Number(right.exactColor) - Number(left.exactColor) ||
          right.titleCoverage - left.titleCoverage ||
          Number(right.product.score || 0) - Number(left.product.score || 0) ||
          left.originalIndex - right.originalIndex
        ))
        .map((item) => item.product);
      data.products = visibleProducts;
      data.count = visibleProducts.length;
      count.textContent = data.count === 1 ? '1 exact option' : `${data.count} exact options`;
      trackSearchEvent('search_results', {
        searchId,
        query: params.get('shaba_request') || '',
        collection,
        count: Number(data.count || 0),
        color: params.get('shaba_color') || '',
        size: params.get('shaba_size') || '',
        budget: params.get('shaba_budget') || '',
        styles: (params.get('shaba_style') || '').split(',').map((term) => term.trim()).filter(Boolean).slice(0, 5),
        occasion: params.get('shaba_occasion') || '',
      });
      if (!data.products.length) {
        const empty = document.createElement('div');
        empty.className = 'shaba-exact-empty';
        empty.innerHTML = '<strong>No exact match yet.</strong><span>Try another colour, size, or budget in the search bar.</span>';
        grid.replaceWith(empty);
        return;
      }
      data.products.forEach((product, index) => {
        const card = buildExactCard(product, data.currencyCode);
        card.addEventListener('click', () => trackSearchEvent('search_result_clicked', {
          searchId,
          query: params.get('shaba_request') || '',
          collection,
          count: Number(data.count || 0),
          position: index + 1,
          product: scrubSearchText(product.title),
          variant: scrubSearchText(product.variantTitle),
        }));
        grid.appendChild(card);
      });
    } catch (error) {
      console.error('Shaba exact search failed', error);
      count.textContent = 'Search needs another try';
      const errorBox = document.createElement('div');
      errorBox.className = 'shaba-exact-empty';
      errorBox.innerHTML = '<strong>We could not finish this search.</strong><span>Please try again in a moment.</span>';
      grid.replaceWith(errorBox);
    }
  }

  function trackNativeResults() {
    const params = new URLSearchParams(window.location.search);
    const request = params.get('shaba_request');
    if (!request || params.get('shaba_exact') === '1') return;
    const main = document.querySelector('#MainContent');
    if (!main || main.dataset.shabaNativeSearchTracked === 'true') return;

    const productLinks = [...main.querySelectorAll('a[href*="/products/"], product-card-link[href*="/products/"]')];
    const uniqueLinks = [...new Map(productLinks.map((link) => [link.getAttribute('href'), link])).values()];
    if (!uniqueLinks.length) return;

    main.dataset.shabaNativeSearchTracked = 'true';
    const searchId = params.get('shaba_search_id') || analyticsId();
    const parsed = parseRequest(request);
    trackSearchEvent('search_results', {
      searchId,
      query: request,
      intent: params.get('shaba_intent') || parsed.intent?.label || '',
      audience: params.get('shaba_audience') || parsed.audience?.label || '',
      occasion: params.get('shaba_occasion') || parsed.occasion?.term || '',
      styles: (params.get('shaba_style') || '').split(',').map((term) => term.trim()).filter(Boolean).slice(0, 5),
      color: params.get('shaba_color') || parsed.color || '',
      size: params.get('shaba_size') || parsed.size || '',
      budget: params.get('shaba_budget') || parsed.budget || '',
      mode: params.get('shaba_mode') === 'smart' ? 'smart' : 'collection',
      count: uniqueLinks.length,
    });

    uniqueLinks.forEach((link, index) => {
      link.addEventListener('click', () => {
        trackSearchEvent('search_result_clicked', {
          searchId,
          query: request,
          count: uniqueLinks.length,
          position: index + 1,
          product: scrubSearchText(link.textContent),
          destination: new URL(link.getAttribute('href'), window.location.origin).pathname,
        });
      }, { once: true });
    });
  }

  window.ShabaFinder = { parseRequest, buildDestination };
  enhanceResultsFinder();
  document.querySelectorAll('[data-shaba-finder]').forEach(activateFinder);
  addFinderConfirmation();
  showSelectedVariantImages();
  renderCatalogResults();
  renderExactResults();
  trackNativeResults();
  window.addEventListener('pageshow', () => {
    addFinderConfirmation();
    showSelectedVariantImages();
    renderCatalogResults();
    renderExactResults();
    trackNativeResults();
  });
  document.addEventListener('shopify:section:load', () => {
    addFinderConfirmation();
    showSelectedVariantImages();
    trackNativeResults();
  });
  const resultsRoot = document.querySelector('#MainContent');
  if (resultsRoot) {
    let imageRefresh;
    new MutationObserver(() => {
      clearTimeout(imageRefresh);
      imageRefresh = setTimeout(() => {
        showSelectedVariantImages();
        trackNativeResults();
      }, 80);
    }).observe(resultsRoot, { childList: true, subtree: true });
  }
})();

